import { UserListFilterType } from '../../types/types';
import { SET_FILTER_DATA } from './types';

const setUserFilterData = (filterData: UserListFilterType) => ({
  type: SET_FILTER_DATA,
  payload: filterData,
});

export default setUserFilterData;
